import { RankedGroupTeam } from "../../models/IGroup";
import { TableWrap } from "../../ui/Table";
import "../StandingsTable/styles.scss";

const ordinal = (position: number) => {
  const lastTwo = position % 100;
  if (lastTwo >= 11 && lastTwo <= 13) return `${position}th`;
  const last = position % 10;
  return `${position}${last === 1 ? "st" : last === 2 ? "nd" : last === 3 ? "rd" : "th"}`;
};

const signed = (value: number) => (value > 0 ? `+${value}` : `${value}`);

// A seed is not a placing, so no medals here.
const SeedingTable = ({ teams }: { teams: RankedGroupTeam[] }) => {
  if (teams.length === 0) return <p className="standings-table-empty seeding-table-empty">No seeding available yet</p>;

  return (
    <TableWrap className="standings-table-container seeding-table-container">
      <table className="ui-table standings-table seeding-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Team</th>
            <th>Group</th>
            <th>Pos</th>
            <th>Sets Diff</th>
            <th>Pts Diff</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team, index) => (
            <tr key={team.teamId}>
              <td>{index + 1}</td>
              <td>{team.teamName}</td>
              <td>{team.groupName}</td>
              <td>{ordinal(team.position)}</td>
              <td>{signed(team.setsDifference)}</td>
              <td>{signed(team.pointDifference)}</td>
              <td>{team.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableWrap>
  );
};

export default SeedingTable;
